//Please add the language resource
const customerSku = {

  msg:{
  }
};
export default customerSku



// WEBPACK FOOTER //
// ./src/page/md/customerSku/lang/customerSku.en.js